// extracted by mini-css-extract-plugin
export default {"label":"repairInvoice_label__L7zrh","deleteButton":"repairInvoice_deleteButton__v9xhW","attachment":"repairInvoice_attachment__otQ2E"};